import React from 'react';
import PropTypes from 'prop-types';

const ErrorNotice = (props) => {
  const { msg } = props;
  return <div className="notification-banner animate">{msg}</div>;
};

ErrorNotice.defaultProps = { msg: 'There was an error' };

ErrorNotice.propTypes = { msg: PropTypes.string };

export default ErrorNotice;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/error_notice.jsx